import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FONT_FAMILY_MAIN, TEXT_COLOR } from '../../theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${TEXT_COLOR};
  margin-bottom: 8px;
`;

const Text = styled.span`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: -0.1px;
  color: ${TEXT_COLOR};
`;

const MeetingsMessage = ({ title, children }) => (
  <Container>
    <Title>{title}</Title>
    <Text>
      {children}
    </Text>
  </Container>
);

MeetingsMessage.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

MeetingsMessage.defaultProps = {
  title: '',
  children: null,
};

export default MeetingsMessage;
